import apiFetch from '../apiFetch'

export default function (token, operationType) {
  return apiFetch({ endPoint: 'OperationType', method: 'POST', body: operationType, token: token })
}
